export default "__VITE_ASSET__d9cb7cc0__"